import { Input } from 'almanac-ui/TextInputField/Input'
import { AlmanacFile, BaseEmoji } from 'types'
import { useLocationPickerProps } from 'components/LocationPicker/hooks/useLocationPicker'
import { useCurrentFolderStore } from 'hooks/stores/useCurrentFolderStore'
import { useDefaultFolder } from 'hooks/queries/projects/useDefaultFolder'
import Styles from './NewFileDrawer.module.scss'
import { Folder } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'
import { EmojiPicker } from 'components/AlmanacFileTitle/EmojiPicker'
import { Button as BlazeButton } from 'blaze-ui/Button'
import { LocationPickerDrawer } from 'components/LocationPicker/LocationPickerDrawer'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { DrawerProps } from 'components/Drawer/Root'
import { useEffect, useState } from 'react'

interface Props extends DrawerProps {
  title: string
  setTitle: (title: string) => void
  emoji: BaseEmoji | null
  setEmoji: (emoji: BaseEmoji | null) => void
  chosenFolder?: AlmanacFile | null
  setChosenFolder: (project?: AlmanacFile | null) => void
}

export const FileLocationPicker = observer(
  ({ title, setTitle, emoji, setEmoji, chosenFolder, setChosenFolder }: Props) => {
    const { drawersStore } = useRootStore()
    const { currentFolder } = useCurrentFolderStore()
    const defaultFolder = useDefaultFolder()
    const [project, setProject] = useState(chosenFolder)
    const destinationFolder = project || currentFolder || defaultFolder
    const locationProps = useLocationPickerProps({
      folder: destinationFolder?.uploads_project ? defaultFolder : destinationFolder,
      onSelectedFolder: (folder) => {
        setProject(folder)
      },
    })

    useEffect(() => {
      setProject(destinationFolder)
      setChosenFolder(destinationFolder)
    }, [currentFolder, defaultFolder, destinationFolder, project, setChosenFolder, setProject])

    return (
      <div className={Styles.locationAndNameContainer}>
        <div className={Styles.label}>
          <Text variant="smallList">File name</Text>
        </div>
        <div className={Styles.searchWrapper}>
          <EmojiPicker emoji={emoji?.native || ''} onSelect={setEmoji} size="lg" />
          <Input
            aria-label="Title"
            name="title"
            size="lg"
            placeholder="Untitled"
            onChange={(event) => setTitle(event.currentTarget.value)}
            value={title === 'Untitled' ? '' : title}
            validationDetails={undefined}
            validationErrors={undefined}
          />
        </div>

        <div className={Styles.section}>
          <div className={Styles.label}>
            <Text variant="smallList">File location</Text>
          </div>
          <div className={Styles.locationPickerButton}>
            <BlazeButton
              onPress={() =>
                drawersStore.openDrawer(LocationPickerDrawer, {
                  ...locationProps.locationPickerProps,
                  actionType: 'create',
                  isRootDisabled: !project,
                })
              }
              variant="secondary"
              size="lg"
              withChevron="down"
              frontIcon={Folder}
              fullWidth
            >
              {project?.title}
            </BlazeButton>
          </div>
        </div>
      </div>
    )
  },
)
